module.exports = __webpack_public_path__ + "img/bananr-gongsi.e3f88784.png";